import React from 'react';
import PropTypes from 'prop-types';
import Videos from '../../../../Marketing/Videos';

class VideosList extends React.Component {
  render() {
    return (
      <Videos
        history={this.props.history}
        productId={this.props.productId}
        location={this.props.location}
      />
    );
  }
}

VideosList.propTypes = {
  productId: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default VideosList;



// WEBPACK FOOTER //
// ./src/Containers/Buy/Catalog/Detail/Videos/index.jsx